module.exports = __webpack_public_path__ + "static/media/bg.6fe1820e.jpg";